const COLUMNAS_EXCEL = [
    {
        value: 0,
        label: "CODE",
        descripcion:
            "",
        verMas: false,
        obligatorio: false,
    },
    {
        value: 1,
        label: "LINE",
        descripcion:
            "",
        verMas: false,
        obligatorio: true,
    },
    {
        value: 2,
        label: "ICCID",
        descripcion:
            "",
        verMas: false,
        obligatorio: true,
    },
    {
        value: 3,
        label: "PROVIDER",
        descripcion:
            "",
        verMas: false,
        obligatorio: true,
    },
];

const INDEX_COLUMNAS_EXCEL = {
    CODE: 0,
    LINE: 1,
    ICCID: 2,
    PROVIDER: 3,
};

const COLUMNAS_EXCEL_STRING = {
    CODE: "CODE",
    LINE: "LINE",
    ICCID: "ICCID",
    PROVIDER: "PROVIDER",
};

export {
    COLUMNAS_EXCEL,
    INDEX_COLUMNAS_EXCEL,
    COLUMNAS_EXCEL_STRING,
}